import { Right } from "constants/right";
import { IWithAgentsState } from "store/entities/agents";
import { Theme } from "themes/helpers";

import { IWithSessionState, hasRight } from "../session";

import { IAppState } from "./reducer";

export interface IWithAppState {
  features: {
    app: IAppState;
  };
}

export function selectIsAppLoaded(state: IWithAppState): boolean {
  return state.features.app.loaded;
}

export function selectTheme(state: IWithAppState): Theme {
  return state.features.app.theme;
}

export function selectIsDarkMode(state: IWithAppState): boolean {
  return state.features.app.theme === Theme.Dark;
}

export function selectCanAccessReports(state: IWithSessionState & IWithAgentsState): boolean {
  return hasRight(state, Right.SeeReports);
}

export function selectCanAccessSettings(state: IWithSessionState & IWithAgentsState): boolean {
  return hasRight(state, Right.SeeSettings);
}

export function selectInitialReferrer(state: IWithAppState): string {
  return state.features.app.initialReferrer;
}
